import { create } from "zustand";
import { persist } from "zustand/middleware";

const createSessionId = () => crypto.randomUUID();

export const useCatalogStore = create(
  persist(
    (set) => ({
      activeCatalogId: null,

      catalogSessionId: createSessionId(),

      sessionRooms: [],

      setActiveCatalogId: (catalogId) =>
        set({
          activeCatalogId: catalogId,
        }),

      setCatalogSessionId: (sessionId) =>
        set({
          catalogSessionId: sessionId,
        }),

      addRoomToSession: (room) =>
        set((state) => ({
          sessionRooms: [
            ...state.sessionRooms,
            room,
          ],
        })),

      startNewCatalogSession: () =>
        set({
          activeCatalogId: null,
          catalogSessionId: createSessionId(),
          sessionRooms: [],
        }),

      clearCatalogSession: () =>
        set({
          activeCatalogId: null,
          catalogSessionId: createSessionId(),
          sessionRooms: [],
        }),
    }),
    {
      name: "catalog-storage",
    }
  )
);